import React from "react";

const NewQuoteFooter = () => {
  const styleDuParagraphe = {
    fontSize: "0.5rem",
    lineHeight: "0.75rem",
  };
  return (
    <div className="text-xl font-bold bg-blueGray-100">
      <div className="container mx-auto px-6 md:max-w-screen-xl flex items-center justify-between py-8">
        <p className="font-light text-blueGray-500" style={styleDuParagraphe}>
          Vos données personnelles sont traitées afin de conclure, gérer et
          exécuter les garanties de votre contrat d’assurance ; réaliser des
          opérations de prospection commerciale ; permettre l’exercice des
          recours et la gestion des réclamations ; conduire des actions de
          recherche et de développement dans le cadre des finalités précitées ;
          mener des actions de prévention ; élaborer des statistiques er études
          actuarielles ; lutter contre la fraude à l’assurance, ; mener des
          actions de lutte contre le blanchiment et le financement du
          terrorisme ; exécuter ses obligations légales, règlementaires et
          administratives en vigueur. Ces données seront conservées pendant
          l’exécution du contrat, puis seront archivées pendant une durée de 5
          ans avant d’être supprimées. Vous disposez d’un droit d’accès, de
          rectification, d’opposition, d’effacement, de limitation et de
          demander la portabilité de certaines données personnelles vous
          concernant, que vous pouvez exercer auprès de Délégué à la Protection
          des données à l’adresse 27 bis boulevard de la république 92210 Saint
          Cloud ou par mail à l’adresse suivante contact@assurancesvelo.com.
          Vous avez également la possibilité de saisir l’autorité de contrôle
          compétente pour la protection des données en France, à savoir, la
          CNIL, en cas de manquements concernant la gestion de vos données
          personnelles.
        </p>
      </div>
    </div>
  );
};

export default NewQuoteFooter;
